import './abstract_section_view.coffee'
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.FourColumnTableView extends Monitoring.Reports.Executive.AbstractSectionView
  id: 'four-column-table-view'
  name: 'four-column-table-view'
  tagName: 'section'
  template: JST["backbone/templates/monitoring/reports/executive/generic_template"]
  chartClass: 'four-column-table'

  initialize: (@options = {}) ->
    @target = { followers: @options.chartApi.twitter_followers, followers_benchmark: @options.chartApi.twitter_followers_benchmark}

  render: ->
    @columns = @getTemplateOptions().columns
    @specific_settings ||= {}

    @specific_settings.benchmark = true
    @$el.html(@template(self: this))
    @bindChartsReady(1)
    @_getTable().addClass('processing')
    query = @labelsQuery(@labelFilter(), @labelsStructure())
    client_tw = @options.settings.accountLabel.twitter_account
    rowColorOption = @getTemplateOptions().rows

    @setBenchmarkSettingsIfNecessary(query)
    $.post(@target[@getTemplateOptions().dimension], _.extend(query, @getExtraQuery()), (response) =>
      tableData = { columns: @columns, data: [], types: ['string', 'number', 'number', 'number'], options: {} }
      if client_tw
        tableData['options'] = { account_description: client_tw, rows: rowColorOption }
      for social_account in response
        @fields = @getTemplateOptions().fields
        tableData.data.push([social_account[@fields[0]], social_account[@fields[1]], social_account[@fields[2]], social_account[@fields[3]]])
      @_getTable().html(new Monitoring.Reports.Executive.TableView(response: tableData).render().el)
      @chartReady(".#{@chartClass}")
    )
    return this

  _getTable: ->
    @$el.find(".#{@chartClass}")
